/**
 * API base URL.
 *
 * In dev, requests to /api/* are proxied to http://localhost:8787 (see vite.config.ts).
 * In production, Cloudflare Pages routes /api/* to the Worker per public/_routes.json.
 */
export const API_BASE = '/api'

/**
 * better-auth email/password sign-in endpoint (POST) — the interim
 * authentication method (Story 2.13). Body: `{ email, password }`.
 */
export const SIGN_IN_EMAIL_URL = `${API_BASE}/auth/sign-in/email`

export const SIGN_OUT_URL = `${API_BASE}/auth/sign-out`
export const ME_URL = `${API_BASE}/me`

/**
 * O login da Genesis pelo `gms-auth` (Epic 35, Story 35.3 na API e 35.4 na tela):
 * `GET config` → `{ mode }`, `GET login?next=` começa o login (uma navegação, nunca
 * um `fetch`) e `POST logout` apaga o cookie da Genesis.
 */
export const GMS_AUTH_CONFIG_URL = `${API_BASE}/gms-auth/config`
export const GMS_AUTH_LOGIN_URL = `${API_BASE}/gms-auth/login`
export const GMS_AUTH_LOGOUT_URL = `${API_BASE}/gms-auth/logout`
